(() => {
  const initializeSection = (section) => {
    if (section.dataset.nabatHomeCareEnhanced === 'true') return;
    const tabs = Array.from(section.querySelectorAll('[data-nabat-care-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-nabat-care-panel]'));
    const isRtl = section.getAttribute('dir') === 'rtl';
    if (!tabs.length || tabs.length !== panels.length) return;

    section.dataset.nabatHomeCareEnhanced = 'true';
    section.classList.add('is-enhanced');

    const select = (nextIndex, focus = false) => {
      tabs.forEach((tab, index) => {
        const selected = index === nextIndex;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        panels[index].hidden = !selected;
      });
      if (focus) {
        tabs[nextIndex].focus();
        tabs[nextIndex].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index));
      tab.addEventListener('keydown', (event) => {
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = isRtl ? (index - 1 + tabs.length) % tabs.length : (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') nextIndex = isRtl ? (index + 1) % tabs.length : (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabs.length - 1;
        else return;
        event.preventDefault();
        select(nextIndex, true);
      });
    });

    select(0);
  };

  const initialize = (root) => {
    if (root.matches?.('[data-nabat-home-care]')) initializeSection(root);
    root.querySelectorAll?.('[data-nabat-home-care]').forEach(initializeSection);
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
